// Constants

export const bumpData = [
  {
  id: '-10',
  name: '-10',
  },
  {
    id: '-9',
    name: '-9',
  },
  {
    id: '-8',
    name: '-8',
  },
  {
    id: '-7',
    name: '-7',
  },
  {
    id: '-6',
    name: '-6',
  },
  {
    id: '-5',
    name: '-5',
  },
  {
    id: '-4',
    name: '-4',
  },
  {
    id: '-3',
    name: '-3',
  },
  {
    id: '-2',
    name: '-2',
  },
  {
    id: '-1',
    name: '-1',
  },
  {
    id: '0',
    name: 'Default',
  },
  {
    id: '1',
    name: '+1',
  },
  {
    id: '2',
    name: '+2',
  },
  {
    id: '3',
    name: '+3',
  },
  {
    id: '4',
    name: '+4',
  },
  {
    id: '5',
    name: '+5',
  },
  {
    id: '6',
    name: '+6',
  },
  {
    id: '7',
    name: '+7',
  },
  {
    id: '8',
    name: '+8',
  },
  {
    id: '9',
    name: '+9',
  },
  {
    id: '10',
    name: '+10',
  }
]
export const bumpMarks = {
  '-10': '-10',
  '0': 'Default',
  '10': '+10'
}
export const defaultERPCSettingBasic = {
  stability: 45,
  newTargetPriority: 55,
  underPerformingTargetPriority: 10,
  countAttempsOn: 'DIAL',
  trackConversionsBy: 'PUBLISHER_CAMPAIGN_TARGET'
}
export const defaultERPCSetting = {
  countAttempsOn: 'DIAL',
  desiredNumberOfCalls: 75,
  desiredNumberOfHours: 720,
  minimumNumberOfCalls: 15,
  newTargetPriority: 55,
  trackConversionBy: 'CAMPAIGN_TARGET',
  underPerformingTargetPriority: 10
}